import type {AiPromptBox, SelectedContextualMenuItems} from '@Components/ai-prompt-box/ai-prompt-box.types';
import type {FooterLeftAction} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {GenerateIdeasOriginator} from '@Libraries/ai-email-campaign-content-library';
import type {ReactElement} from 'react';

export interface AiGenerationBoxProps<T> {
  id: string;
  sessionStorageKey: string;
  initialConfig: AiPromptBox;
  fetchRecents: () => Promise<T[]>;
  onGenerate: (prompt: string, options: SelectedContextualMenuItems, originator: GenerateIdeasOriginator) => Promise<T[]>;
  canGenerate?: () => boolean;
  onItemSelect: (item: T, prompt: string) => void;
  getItemKey: (item: T) => string;
  options: FooterLeftAction[];
  renderItem?: (item: T) => ReactElement;
  aiPromptBoxPreviewText?: string;
  showRetryOnError?: boolean;
  isMobile?: boolean;
  customPopupClasses?: string;
}

export enum AiGenerationBoxErrorCode {
  DAILY_LIMIT_REACHED = 'daily-limit-reached',
  UNEXPECTED_ERROR = 'unexpected-error',
}

export interface SplitSection {
  key: string;
  content: ReactElement;
}
